import React from 'react';
import {MaskService, TextInputMaskOptionProp} from 'react-native-masked-text';

type InputMaskedType = {
  value: string | undefined;
  onChange: React.Dispatch<React.SetStateAction<string | undefined>>;
};

// generates an object containing the input required properties (value and onChange) and handles state
export const useMaskedInputState = (initialValue?: string) => {
  const [value, onChange] = React.useState(initialValue);
  return {value, onChange};
};

export const buildMaskInputProps = (
  {value = '', onChange}: InputMaskedType,
  type: string,
  options?: TextInputMaskOptionProp,
) => ({
  value: MaskService.toMask(type, value, options),
  onChangeText: (newValue: any) =>
    onChange(MaskService.toRawValue(type, newValue, options)),
});
